import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../../ui/dialog';
import { haccpApi, erroreHaccp } from '../haccpApi';
import { CartellaVista } from './CartellaVista';

const mostra = (w, blob) => {
  const url = URL.createObjectURL(blob);
  if (w) { w.location.href = url; return; }
  Object.assign(document.createElement('a'), { href: url, target: '_blank', rel: 'noopener' }).click();
};

export const AnteprimaIspettore = ({ profilo, onClose }) => {
  const [dati, setDati] = useState(null);
  const [aprendo, setAprendo] = useState(null);

  useEffect(() => {
    setDati(null);
    if (!profilo) return;
    haccpApi.get(`/ispettore/${profilo}/anteprima`).then(setDati).catch((e) => toast.error(erroreHaccp(e, 'Anteprima non disponibile')));
  }, [profilo]);

  const apri = async (v) => {
    const w = window.open('', '_blank');
    setAprendo(v.id);
    try {
      const [codice, periodo] = v.id.split(':');
      const path = v.tipo === 'registro' ? `/ispettore/${profilo}/registro/${codice}?periodo=${encodeURIComponent(periodo)}` : `/ispettore/${profilo}/documento/${v.id}`;
      mostra(w, await haccpApi.get(path, { responseType: 'blob', timeout: 180000 }));
    } catch { w?.close(); toast.error('Documento non disponibile'); } finally { setAprendo(null); }
  };

  return (
    <Dialog open={!!profilo} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-4xl w-[95vw] max-h-[90vh] overflow-y-auto bg-slate-50 p-0 gap-0" data-testid="owner-preview-dialog">
        <DialogHeader className="bg-slate-950 text-white p-5 text-left">
          <DialogTitle className="text-lg font-extrabold">Così la vede l'ispettore</DialogTitle>
          <DialogDescription className="text-slate-300">{dati?.profilo.nome || ''} · le tue aperture qui non finiscono nel registro e non inviano avvisi.</DialogDescription>
        </DialogHeader>
        <div className="p-4 lg:p-6">
          {dati ? <CartellaVista dati={dati} onApri={apri} aprendo={aprendo} /> : <Loader2 className="h-6 w-6 animate-spin text-slate-400 mx-auto my-10" />}
        </div>
      </DialogContent>
    </Dialog>
  );
};
